export default "__VITE_ASSET__4f589600__"